import template from './results.tpl';
import BaseStep from './../BaseStep';
import {gsap} from 'gsap';
import MainController from '../../../../controller/MainController';
import AppStateModel from '../../../../model/appStateModel';
import LifespanModel from './../../model/lifespanModel';
import ResultDiagram from './../../../../components/resultdiagram/resultDiagram';
import Tooltip from '../../../../components/tooltip/tooltip'




class ResultsSelection extends BaseStep {
    private diagram: ResultDiagram | null = null;

    constructor(id: string, data: any) {
        super(id, data);

        this._data.user_birthday = AppStateModel.birthday;
        this._data.estimated_age = AppStateModel.estimated_age;
        this._data.gender_style = AppStateModel.gender;

        // TODO to jump straight to this step in dev, uncomment these values...
        /*if (!LifespanModel.birthday) {
            this._data.user_birthday = 1940;
            this._data.estimated_age = 73;
            gender = 'w';
        }*/


        this._data.results = LifespanModel.getResultsByBirthdayAndGender();
        this._data.results.p = this._data.results.p.toFixed(this._data.steps.results.decimals);
        this._data.results.text = this.getResultsLabel(this._data.estimated_age, this._data.results.p);

        // change format for numbers
        this._data.results.p = this._data.results.p.toString().replace('.', ',');

        this._template = template(this._data);
    }

    getResultsLabel(estimate, prognosis) {
        let x = parseFloat(estimate) - parseFloat(prognosis);
        let texts = {headline: '', copy: ''};

        // This is intended to cover all possible estimate/prognosis differences, divided into intervals WITHOUT gaps.
        if (x <= -8)
            texts = this._data.steps.results.labels.BBBB;

        else if (-8 < x && x <= -7)
            texts = this._data.steps.results.labels.BBB;

        else if (-7 < x && x <= -4)
            texts = this._data.steps.results.labels.BB;

        else if (-4 < x && x < 0)
            texts = this._data.steps.results.labels.B;

        else if (0 == x)
            texts = this._data.steps.results.labels.exact;

        else if (0 < x && x <= 4)
            texts = this._data.steps.results.labels.A;

        else if (4 < x && x <= 8)
            texts = this._data.steps.results.labels.AA;

        else if (8 < x && x <= 12)
            texts = this._data.steps.results.labels.AAA;

        else if (12 < x)
            texts = this._data.steps.results.labels.AAAA;

        else console.error('COULD NOT derive a result message from value:', x);

        return texts;
    }

    render() {
        super.render();

        if (!this._element) return;

        let minAge = 60;
        let maxAge = 115;
        let percent80 = this._data.results['80'];
        let percent50 = this._data.results['50'];
        let percent20 = this._data.results['20'];
        let presumedAge = this._data.results.k; // k from cohort table
        let estimatedAge = this._data.estimated_age;
        this.diagram = new ResultDiagram(minAge, maxAge, percent80, percent50, percent20, presumedAge, estimatedAge);

        const diagramContainer = this._element.querySelector('#diagram') as HTMLElement;
        if (diagramContainer) {
            this.diagram.appendTo(diagramContainer, this.triggerPopup);
        }

        const tooltip = new Tooltip(this._data.source_tooltip.link,this._data.source_tooltip.headline,
            this._data.source_tooltip.text );
        const tooltipContainer = this._element.querySelector('div.source_tooltip') as HTMLElement;
        if (tooltipContainer) {
            tooltip.appendTo(tooltipContainer);
        }
    }

    postRender() {
        this.setAnimationElements();

        // enable sharing for this view/step
        MainController.setSharing(true);
    }

    triggerPopup() {
        // draw attention to the user that there is a menu-bar for further exploration, after a few seconds.
        MainController.navigationBar.showHintPopup(3);
    }

    setAnimationElements() {
        if (!this._element || !this.diagram) return;

        this.animationElements = {
            diagram: this.diagram.element,
            scale: this._element.querySelectorAll('g.scale'),
            headline: this._element.querySelector('#results_headline'),
            copy: this._element.querySelector('#results_copy'),
            percentageWrapper: this._element.querySelectorAll('.percentage_wrapper'),
            hr: this._element.querySelectorAll('hr'),
            legend: this._element.querySelectorAll('.legend'),
            legendEntryFirst: this._element.querySelectorAll('.legend_entry:nth-child(1)'),
            legendEntryNotFirst: this._element.querySelectorAll('.legend_entry + .legend_entry'),
        };
    }

    getShowAnimation(): any[] {
        let animations: any[] = [];

        let a = this.animationElements;
        let message = [a.headline, a.copy].filter(Boolean);

        // diagram:
        if (a.diagram) {
            animations.push(gsap.from(a.diagram, 0.8, {delay: 0.5, autoAlpha: 0}));
        }
        if (a.scale) {
            animations.push(gsap.from(a.scale, 0.8, {
                delay: 0.5,
            transformOrigin: '50% 96%',
            rotation: 45
            }));
        }

        // legend:
        if (a.legendEntryFirst) {
            animations.push(gsap.from(a.legendEntryFirst, 0, {delay: 1.3, autoAlpha: 0}));
        }
        if (a.legendEntryNotFirst) {
            for (let i = 0; i < a.legendEntryNotFirst.length; i++) {
                animations.push(gsap.from(a.legendEntryNotFirst[i], 0.6, {
                    delay: 0.7 * i,
                    'margin-left': '-20em'
                }));
            }
        }

        // hr, text & percentage_wrapper:
        if (a.hr) {
            animations.push(gsap.from(a.hr, 0.8, {delay: 0.3, autoAlpha: 0, top: '75%'}));
        }
        if (message.length > 0) {
            animations.push(gsap.fromTo(message, 1, {autoAlpha: 0, 'margin-top': '100%'}, {
                autoAlpha: 1,
                'margin-top': '0%'
            }));
        }
        if (a.percentageWrapper) {
            animations.push(gsap.fromTo(a.percentageWrapper, 0.7, {autoAlpha: 0, 'margin-top': '50%'}, {
                delay: 0.6,
                autoAlpha: 1,
                'margin-top': '0%'
            }));
        }

        return animations;
    }

    getHideAnimation(): any[] {
        let animations: any[] = [];

        // add tweens to animate...

        return animations;
    }
}
export default ResultsSelection;
